import createListStore from '@product-framework/store/createListStore';

/** Key on rootStore.uiState; list page uses storeName 'FlowDefinitionList' for store.domain.list.get/set/reset(). */
export const LIST_STORE = 'flowDefinitionsListStore';
const FlowDefinitionsListStore = createListStore(LIST_STORE);
export default FlowDefinitionsListStore;
